export default {
  coverage_network: "Rede de abrangência",
  list_unities: "Lista de unidades",
  register_unity: "Cadastrar unidade",
  update_unity: "Atualizar unidade",
  ppp: "Controle de solicitação de Exames de imagem",
  procedures: "Procedimentos",
  bind_procedure: "Vincular procedimento",
  unbind_procedure: "Desvincular procedimento",
  districts: "Distritos sanitários",
  checking_coverage: "Verificando abrangência",
  checking_unity_coverage:
    "Verificando se o paciente está dentro da abrangência da unidade",
  without_coverage: "Fora da abrangência",
  patient_without_coverage:
    "O paciente selecionado encontra-se fora da área de abrangência da unidade",
  patient_without_districts:
    "O paciente selecionado encontra-se fora da área de distritos da unidade",
  error_neighborhoods: "Erro ao verificar bairro do paciente",
  erro_check_neighborhoods:
    "Não foi possível verificar a compatibilidade do bairro do paciente com a unidade",
  patient_neighborhoods: "Bairro do paciente",
  add_exclusivity: "Adicionar exclusividade",
  list_exclusivities: "Lista de exclusividades",
  waiting: "Aguarde...",
  checking_exclusives: "Verificando exclusividades",
  unity_has_exclusivity:
    "A unidade selecionada possui regime de exclusividade de oferta do procedimento",
  to_continue_patient_regulation:
    "Deseja continuar com a regulação do Paciente?",
  searching_unities: "Buscando unidades",
  identification: "Identificação",
  address: "Endereço",
  specificities: "Especificidades",
  integrations: "Integrações",
  couverages_list: "Lista de abrangências",
  districts_list: "Distritos sanitários",
};
